import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-114">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative px-8 py-12 md:p-16 text-center border border-gold/30 rounded-3xl bg-cream/30" data-id="element-116">
          {/* Decorative quotes */}
          <span className="absolute top-6 left-8 text-6xl text-gold/20 font-serif leading-none" data-id="element-117">
            "
          </span>
          <span className="absolute bottom-0 right-8 text-6xl text-gold/20 font-serif leading-none rotate-180" data-id="element-118">
            "
          </span>

          <p className="text-xl md:text-2xl font-playfair text-brown-heading leading-relaxed relative z-10" data-id="element-119">
            En solo 7 días, pasarás de la ansiedad de no saber qué hacer, a la
            confianza absoluta de tener un plan de acción natural. Sabrás
            distinguir entre una fiebre necesaria y una que requiere atención, y
            tendrás las herramientas para que tu hijo duerma tranquilo a pesar
            de las molestias del crecimiento.
          </p>
        </motion.div>
      </div>
    </section>;
}